import otherJob from "../images/signup_images/others-func.svg";

export const locationList = [
  "North America",
  "ASEAN",
  "Western Europe",
  "Central and Eastern Europe",
  "LATAM",
  "Africa",
];

export const affricanCountries = [
  "dz",
  "ao",
  "bj",
  "bw",
  "bf",
  "bi",
  "cm",
  "cv",
  "cf",
  "td",
  "km",
  "cd",
  "dj",
  "eg",
  "gq",
  "er",
  "et",
  "ga",
  "gm",
  "gh",
  "gn",
  "gw",
  "ci",
  "ke",
  "ls",
  "lr",
  "ly",
  "mg",
  "mw",
  "ml",
  "mr",
  "mu",
  "yt",
  "ma",
  "mz",
  "na",
  "ne",
  "ng",
  "cg",
  "re",
  "rw",
  "sh",
  "st",
  "sn",
  "sc",
  "sl",
  "so",
  "za",
  "ss",
  "sd",
  "sz",
  "tz",
  "tg",
  "tn",
  "ug",
  "eh",
  "zm",
  "zw",
];
export const northAmericanCountries = [
  "ai",
  "ag",
  "aw",
  "bb",
  "bz",
  "bm",
  "bq",
  "vg",
  "ca",
  "ky",
  // "cr",
  // "cu",
  "cw",
  "dm",
  // "do",
  // "sv",
  "gl",
  "gd",
  "gp",
  // "gt",
  // "ht",
  // "hn",
  "jm",
  "mq",
  // "mx",
  "ms",
  "an",
  // "ni",
  // "pa",
  "pr",
  "bl",
  "kn",
  "lc",
  "mf",
  "pm",
  "vc",
  "sx",
  "bs",
  "tt",
  "tc",
  "us",
  "vi",
];
export const centralAndEasternEuropeCountriesList = [
  "at",
  "be",
  "bg",
  "hr",
  "cy",
  "cz",
  "dk",
  "ee",
  "fi",
  "fr",
  "de",
  "gr",
  "hu",
  "ie",
  "it",
  "lv",
  "lt",
  "lu",
  "mt",
  "nl",
  "pl",
  "pt",
  "ro",
  "sk",
  "si",
  "es",
  "se",
  "al",
  "ad",
  "am",
  "by",
  "ba",
  "fo",
  "ge",
  "gi",
  "is",
  "im",
  "xk",
  "li",
  "mk",
  "md",
  "mc",
  "me",
  "no",
  "ru",
  "sm",
  "rs",
  "ch",
  "tr",
  "ua",
  "gb",
  "va",
];

export const LATAMCountries = [
  "ag",
  "ai",
  "ar",
  "aw",
  "bb",
  "bm",
  "bo",
  "br",
  "bs",
  "bz",
  "cl",
  "co",
  "cr",
  "cu",
  "dm",
  "do",
  "ec",
  "fk",
  "gd",
  "gs",
  "gt",
  "gy",
  "hn",
  "ht",
  "jm",
  "kn",
  "ky",
  "lc",
  "ms",
  "mx",
  "ni",
  "pa",
  "pe",
  "pr",
  "py",
  "sr",
  "sv",
  "tc",
  "tt",
  "uy",
  "vc",
  "ve",
  "vg",
  "vi",
];

export const ASEANCountries = [
  "as",
  "au",
  "bd",
  "bn",
  "bt",
  "cc",
  "cn",
  "cx",
  "fj",
  "fm",
  "gu",
  "hk",
  "id",
  "in",
  "io",
  "jp",
  "kh",
  "ki",
  "kp",
  "kr",
  "la",
  "lk",
  "mh",
  "mm",
  "mn",
  "mo",
  "mp",
  "mv",
  "my",
  "nf",
  "np",
  "nr",
  "nu",
  "nz",
  "pg",
  "ph",
  "pk",
  "pn",
  "pw",
  "sb",
  "sg",
  "th",
  "tk",
  "tl",
  "to",
  "tv",
  "tw",
  "um",
  "vn",
  "vu",
  "ws",
  "kz",
  "uz",
  "tm",
  "kg",
  "af",
  "tj",
];
export const westernSuropeCountries = [
  "bh",
  "cy",
  "eg",
  "ir",
  "iq",
  "il",
  "jo",
  "kw",
  "lb",
  "om",
  "ps",
  "qa",
  "sa",
  "tr",
  "ae",
  "ye",
  "sy",
];

// export const jobRoleList = [
//   {
//     name: "Data Scientist",
//     icon: scientistIcon,
//   },
//   {
//     name: "Data Engineer",
//     icon: webDevelopmentIcon,
//   },
//   {
//     name: "Business Analyst",
//     icon: dataScientistIcon,
//   },
//   {
//     name: "Business User",
//     icon: businessmanIcon,
//   },
//   {
//     name: "Software Engineer",
//     icon: businessmanIcon,
//   },
//   {
//     name: "Software Architect",
//     icon: businessmanIcon,
//   },
//   {
//     name: "Director",
//     icon: businessmanIcon,
//   },
//   {
//     name: "Product Owner",
//     icon: businessmanIcon,
//   },
//   {
//     name: "NALT",
//     icon: businessmanIcon,
//   },
//   {
//     name: "NOLT",
//     icon: businessmanIcon,
//   },
//   {
//     name: "Others",
//     icon: otherJob,
//   },
// ];

export const jobRoleList = [
  {
    name: "Data Scientist",
    icon: otherJob,
  },
  {
    name: "Data Engineer",
    icon: otherJob,
  },
  {
    name: "Business Analyst",
    icon: otherJob,
  },
  {
    name: "Business User",
    icon: otherJob,
  },
  {
    name: "Software Engineer",
    icon: otherJob,
  },
  {
    name: "Software Architect",
    icon: otherJob,
  },
  {
    name: "Director",
    icon: otherJob,
  },
  {
    name: "Product Owner",
    icon: otherJob,
  },
  {
    name: "NALT",
    icon: otherJob,
  },
  {
    name: "NOLT",
    icon: otherJob,
  },
  {
    name: "Others",
    icon: otherJob,
  },
];
